var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C10 19.5304 10.2107 20.0391 10.5858 20.4142C10.9609 20.7893 11.4696 21 12 21C12.5304 21 13.0391 20.7893 13.4142 20.4142C13.7893 20.0391 14 19.5304 14 19M12.927 2.566L12.467 2.5L12.499 2.036L12.5 2V1C12.5 0.867392 12.4473 0.740215 12.3536 0.646447C12.2598 0.552678 12.1326 0.5 12 0.5C11.8674 0.5 11.7402 0.552678 11.6464 0.646447C11.5527 0.740215 11.5 0.867392 11.5 1V2L11.501 2.036L11.534 2.5L11.074 2.566C9.52651 2.78894 8.1112 3.56211 7.08746 4.7438C6.06372 5.92548 5.50014 7.43653 5.5 9V15.5H4C3.60218 15.5 3.22064 15.658 2.93934 15.9393C2.65804 16.2206 2.5 16.6022 2.5 17C2.5 17.3978 2.65804 17.7794 2.93934 18.0607C3.22064 18.342 3.60218 18.5 4 18.5H20C20.3978 18.5 20.7794 18.342 21.0607 18.0607C21.342 17.7794 21.5 17.3978 21.5 17C21.5 16.6022 21.342 16.2206 21.0607 15.9393C20.7794 15.658 20.3978 15.5 20 15.5H18.5V9C18.4999 7.43668 17.9365 5.92575 16.9129 4.74409C15.8894 3.56242 14.4743 2.78916 12.927 2.566Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.68e0d90c29b61f8f7475e46985df714c.svg";
export { ForwardRef as ReactComponent };